import {useEffect, useState} from 'react';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {Button, Divider, Form, Message, Segment} from 'semantic-ui-react';
import FormInput from './forms/input';
import {required, smsKey} from './forms';
import PropTypes from 'prop-types';

function SMSKeyForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  const DEFAULT_TIME_LEFT = 60;
  const [timeLeft, setTimeLeft] = useState(DEFAULT_TIME_LEFT);

  useEffect(
    function () {
      const timer = setTimeout(function () {
        setTimeLeft(timeLeft => (timeLeft > 0) ? (timeLeft - 1) : 0);
      }, 1000);
      return function () {
        clearInterval(timer);
      };
    }
  );

  async function submit({smsKey}) {
    try {
      await props.onSubmit(smsKey);
    } catch (error) {
      if (error.data && error.data.hasOwnProperty('smsKey')) {
        throw new SubmissionError({smsKey: error.data.smsKey});
      } else if (error.status === 403) {
        const errorMessage = error.data.detail || 'محدودیت ارسال کد تایید شما به پایان رسیده است.';
        props.onError(errorMessage);
      } else {
        const errorMessage = error.data.detail || error.data || 'کد وارد شده اشتباه است.';
        throw new SubmissionError({_error: errorMessage});
      }
    }
  }

  async function resend() {
    try {
      await props.onResend();
      setTimeLeft(DEFAULT_TIME_LEFT);
    } catch (error) {
      const errorMessage = error.message || 'محدودیت ارسال کد تایید شما به پایان رسیده است.';
      props.onError(errorMessage);
    }
  }

  return (
    <Segment>
      {props.showTitle && (<Divider horizontal content='فرم ارسال کد احراز هویت' className='mb-5'/>)}

      <div className='text-center text-large'>
        <p>
          شماره تلفن همراه:
          {' '}
          {props.mobile}
        </p>
        {(props.back) && (<Button basic primary onClick={props.onBack}>تغییر شماره تلفن همراه</Button>)}
      </div>

      <Divider className='my-4'/>
      <p className='text-center'>یک کد 6 رقمی برای شما ارسال شد، لطفا کد ارسال شده را وارد نمایید.</p>

      {/*form error*/}
      {error && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
        <Field
          required
          name='smsKey'
          label='کد احراز هویت'
          placeholder='کد ارسال شده به شماره همراه'
          fluid={false}
          component={FormInput}
          validate={[required, smsKey]}
        />
        <Button
          basic
          positive
          type='submit'
          disabled={pristine || submitting}
          content='ادامه'
        />
      </Form>

      <Divider className='mb-4'/>

      <div className='text-center text-large'>
        {(timeLeft > 0) ? `زمان انتظار برای ارسال مجدد: ${timeLeft} ثانیه` : (
          <Button
            basic
            color='orange'
            disabled={timeLeft > 0}
            content='ارسال مجدد کد'
            onClick={resend}
          />
        )}
      </div>
    </Segment>
  );
}

SMSKeyForm.defaultProps = {showTitle: true, back: false, onBack: () => null};

SMSKeyForm.propTypes = {
  showTitle: PropTypes.bool.isRequired,
  back: PropTypes.bool.isRequired,
  mobile: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
};

export default reduxForm({form: 'sms-key'})(SMSKeyForm);
